module.exports = __webpack_public_path__ + "img/ruzhi.681c233e.png";